export var FAVOURITE_BUTTON_CLASSNAME = 'favourite-button';
export var FAVOURITE_TRANSITION_CLASSNAME = 'favourite-button__icon-wrapper--transition';
export var FAVOURITE_ICON_TRANISITION_DURATION_IN_MS = 300;